<template>
  <div>
    <select-bar
      :select-bar="selectBar"
      @selectType = "selectType"/>

    <LjbHeader :title="title"/>
    <module-title :module-title = "moduleTitle"/>
    <popup-toast
      :show-popup="showPopup"
      :popup-info="popupInfo"/>
    <list-order-info/>
    <pay-list/>
    <text-title
      :title="textTitle.title"
      :right-part="textTitle.rightPart"/>

    <normal-btn
      :btn-text="btnText"
      @btnClick="btnClick"/>
    <order-state :state="state"/>
    <fix-btn :btn-info="btnInfo"/>
    <popup-pay :pay-info="payInfo"/>
  </div>
</template>

<script>
import PopupToast from '@/components/popup/PopupToast'
import ModuleTitle from '@/components/title/ModuleTitle'
// import Headers from '@/components/common/LjbHeader'
import FixBtn from '@/components/common/FixBtn'
import SelectBar from '@/components/SelectBar'
import PayList from '@/components/pay/payList'
import ListOrderInfo from '@/components/list/listOrderInfo'
import NormalBtn from '@/components/common/NormalBtn'
import OrderState from '@/components/orderState'
import PopupUpglide from '@/components/popup/PopupUpglide'
import PopupPay from '@/components/pay/PopupPay'
import TextTitle from '@/components/title/TextTitle'
import LjbHeader from '@/components/common/LjbHeader'
export default {
  components: {
    LjbHeader,
    TextTitle,
    PopupPay,
    PopupUpglide,
    OrderState,
    NormalBtn,
    ListOrderInfo,
    PayList,
    SelectBar,
    FixBtn,
    ModuleTitle,
    PopupToast},
  data () {
    return {
      payInfo: {
        showPopup: false,
        price: '120',
        title: '电话咨询'
      },
      state: {
        src: 'https://cdn.51ljb.cn/home_ypb_colorful.png',
        title: '订单已完成',
        text: '您的订单已完成，如有问题请及时查看'
      },
      btnText: '提交评价',
      textTitle: {
        title: '咨询总额',
        rightPart: '120'
      },
      selectBar: {
        index: '0',
        selectList: [{
          type: '进行中'
        }, {
          type: '已完成'
        }, {
          type: '已取消'
        }]
      },
      title: '首页',
      showPopup: false,
      popupInfo: { // 弹窗信息
        src: 'https://cdn.51ljb.cn/ypb_success.png',
        title: '提交成功',
        text: '工作人员将在1-2个工作日内审核，',
        subText: '敬请留意通知！',
        showBtn: true
      },
      moduleTitle: {
        title: '电话咨询',
        text: '60秒闪电接通专业律师'
      },
      btnInfo: {
        showPrice: true,
        price: '6元/分钟',
        text: '不足一分钟无需付费',
        btnText: '立即咨询',
        isGray: true
      }
    }
  },
  methods: {
    selectType (key) {
      this.selectBar.index = key
    },
    btnClick () {
      this.payInfo.showPopup = true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/HelloWorld.vue